import { render, staticRenderFns } from "./SudRegTrazilica.vue?vue&type=template&id=09b945d6&scoped=true"
import script from "./SudRegTrazilica.vue?vue&type=script&lang=js"
export * from "./SudRegTrazilica.vue?vue&type=script&lang=js"
import style0 from "./SudRegTrazilica.vue?vue&type=style&index=0&id=09b945d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b945d6",
  null
  
)

export default component.exports